export default __webpack_public_path__ + "static/media/logo.99643bd3.jpg";